<template>
  <div class="header">
    <div>
      <el-button @click="toggleCollapse()" type="text" style="margin-left: 10px">
        <i style="font-size: 32px" :class="$store.state.collapse?'el-icon-s-unfold':'el-icon-s-fold'"></i>
      </el-button>
    </div>
    <div>
      <img class="icon1" src="../../static/images/geren.png" alt="" srcset="">
      <span>{{ userName }}</span>
      <el-dropdown @command="handleCommand">
        <img class="icon1" src="../../static/images/tuichu.png" alt="" srcset="">
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="resetPass">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {removeToken, removeUserInfo} from '@/utils/auth'
import {mapMutations} from 'vuex'

export default {
  computed: {
    userName() {
      if (this.$store.state.user.userInfo) {
        return this.$store.state.user.userInfo.username
      } else {
        return {}
      }
    }
  },
  methods: {
    ...mapMutations('user', ['REMOVE_TOKEN', 'REMOVE_USERINFO']),
    handleCommand(command) {
      if (command === 'logout') {
        removeToken();
        removeUserInfo();
        this.REMOVE_TOKEN();
        this.REMOVE_USERINFO();
        this.$router.push('/login');
      } else if (command === 'resetPass') {
        this.$router.push('/reset/pass')
      }
    },
    //点击按钮，切换菜单的折叠与展开
    toggleCollapse() {
      this.$store.state.collapse = !this.$store.state.collapse
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  height: 50px;
  padding-right: 46.5px;
  line-height: 50px;
  background: #FFFFFF;
  display: flex;
  justify-content: space-between;
}

span {
  font-size: 16px;
  font-weight: bold;
  color: #0B0C18;
  margin: 0 57px 0 17px;
  vertical-align: middle;
}

.icon1 {
  height: 16px;
  vertical-align: middle;
}
</style>